type TranslationField = Record<string, { name?: any } | undefined>;

export const isEmptyTranslation = (value: any) => {
    if (value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value !== 'string') return false;
    return value.replace(/<p><br><\/p>/g, '').replace(/&nbsp;/g, ' ').trim() === '';
};

// Copies the text from a filled language into every language left empty, so that
// e.g. entering only "en" also saves the same text for "ee" and vice versa.
export const fillMissingTranslations = (fields: TranslationField[], preferredLocale = 'en') => {
    fields.forEach(field => {
        if (!field) return;
        const locales = Object.keys(field);
        const source = [preferredLocale].concat(locales).find(locale => field[locale] && !isEmptyTranslation(field[locale]?.name));
        if (!source) return;
        locales.forEach(locale => {
            if (!field[locale]) field[locale] = { name: '' };
            if (isEmptyTranslation(field[locale]?.name)) {
                (field[locale] as Record<any, any>).name = field[source]?.name;
            }
        });
    });
};
